import { ParameterTypeEnum } from "../enums/parameterType.enum";
import { ParameterValue } from "./recordDto.model";

export class NodeRecord {
    timestamp: number;
    value: number;
    values: NodeRecordParameterValue;
    endPointId?: string;
    cumulativeSum?: number;
    cumulativeSumPercentage?: number;
}
  
export type NodeRecordParameterValue = {
    [key in ParameterTypeEnum]?: number;
};
  
export class SensorRecord {
    timestamp: number;
    deviceId: string;
    statusId: number;
    hum: number;
    lat: number;
    lon: number;
    pm1: number;
    pm2_5: number;
    pm10: number;
    rssi: number;
    tempC: number;
    feelsLikeC: number;
    hdop: number;
    endPointName: string;
    deviceName: string;
    respirablePm: number;
    lavg: number;
    ozone: number;
    nO2: number;
    co: number;
    sO2: number;
    tvoc: number;
    cO2: number;
    endPointId?: string;
    cumulativeSum?: number;
    cumulativeSumPercentage?: number;
    accel: string;
    applyPmDensity: boolean;
    batt_volt: number;
    batteryCharging: number;
    batteryPercentage: number;
    binCounts: number[];
    binMass: number[];
    bus_volt: number;
    current: number;
    dewPoint: number;
    opcHum: number;
    opcTempC: number;
    parameterPercentage: number;
    parameterValue: ParameterValue;
    pm0_3Particles: number;
    pm0_5Particles: number;
    pm1Neph: number;
    pm1_0Particles: number;
    pm2_5Neph: number;
    pm2_5Particles: number;
    pm5_0Particles: number;
    pm10Neph: number;
    pm10Particles: number;
    powerState: number;
    pressure: number;
    respirablePmNeph: number;
    samplingPeriod: number;
    sfr: number;
    signal_strength: number;
    sys_current: number;
    windDir: number;
    windSpeed: number;
    trolex_MeasuredRCS: number;
    trolex_FlowRate_ml_min: number;
    trolex_TempC: number;
    trolex_Humidity_percent: number;
}
